const COLOR_ALIAS: Record<string, string> = {
  белая: 'белый',
  белые: 'белый',
  белый: 'белый',
  черная: 'черный',
  черный: 'черный',
  черные: 'черный',
  синий: 'синий',
  синие: 'синий',
  темносиний: 'темносиний',
  голубая: 'голубой',
  голубой: 'голубой',
  василек: 'василек',
  красная: 'красный',
  красный: 'красный',
  бордовая: 'бордовый',
  бордовый: 'бордовый',
  графит: 'графит',
  серый: 'серый',
  свсерый: 'свсерый',
  темносерый: 'темносерый',
  темнозеленый: 'темнозеленый',
  зеленая: 'зеленый',
  зеленый: 'зеленый',
  лайм: 'лайм',
  лимонный: 'лимонный',
  бежевый: 'бежевый',
  бежевые: 'бежевый',
  коричневый: 'коричневый',
  хаки: 'хаки',
  оранжевый: 'оранжевый',
  розовый: 'розовый',
  фиолетовый: 'фиолетовый',
}

export const normalizeColor = (value: string): string | null => {
  if (!value) return null
  let v = value.toLowerCase().trim()

  // если есть русский цвет в скобках — берем его
  const ruMatch = v.match(/\(([^)]*[а-яё][^)]*)\)/)
  if (ruMatch) v = ruMatch[1]

  // удаляем "арт....", лишние слова, цифры
  v = v.replace(/арт\.[^-\s]+/g, '')
       .replace(/доставка|удлиненная|полоса|полоска|тк\.[^,\s]+|с свп/g, '')
       .replace(/[^a-zа-яё\/]/g, '')
       .trim()

  if (!v) return null

  // применяем алиасы
  if (COLOR_ALIAS[v]) return COLOR_ALIAS[v]

  return v
}